module.exports = __webpack_public_path__ + "media/images/icons/web_blue-b632d13e664715a6314cbba71cec4033.svg";